module.exports = __webpack_public_path__ + "static/media/goods9.d63f1cc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/goods9.png
// module id = 142
// module chunks = 0